import React, { useEffect } from "react";
import 'styles/main/Header.sass'
import ProductSearch from 'components/controls/ProductSearch';
import { useSelector, useDispatch } from 'react-redux';


export default function Header(props) {
  const loading = useSelector((state) => state.loading);
  const dispatch = useDispatch();
  const about = useSelector((state) => state.about);

  useEffect(() => { 
    console.log('render Header')
  });

//        {loading == false && <ProductSearch />}

  return (
    <div id="header">
        <a href="https://www.copernicus.eu/" target="_blank"><div id="logoA" /></a>
        <a href="https://marine.copernicus.eu/" target="_blank"><div id="logoB" /></a>
        <div id="separator" />
        <div id="title" >
          <p className="titleTop">Product Quality</p>
          <p className="titleBot">Dashboard</p>
        </div>
        <div id="aboutCont" >
          <div id="about" onClick={() => {dispatch({ type: 'SET_ABOUT', payload: !about})}}>About</div>
        </div>
        <span></span>
    </div>
  )
}
